export const SPONSOR = "sponsor";
export const PLATINUM_SPONSOR = "platinumSponsor";
export const PLATINUM_AND_SPONSOR = "platinumAndSponsor";
export const INTERNATIONAL_SPONSOR = "internationalSponsor";
export const FOSTER_SPONSOR = "fosterSponsor";
export const PLATINUM_FOSTER_SPONSOR = "platinumFosterSponsor";
